import { ILocaleInfo } from "src/app/services/utility.service";
import { constants } from "src/environments/constants";
import { environment } from "src/environments/environment";

export class InsightInventoryItem {
  ID: string = "";
  BacklitKeyboard: boolean = false;
  HasFingerprintReader: boolean = false;
  HasPrivacyScreen: boolean = false;
  HasStylus: boolean = false;
  Category: string = "";
  CategoryID: string = "";
  CnetProdId: string = "";
  CpuFrequency: string = "";
  CpuModel: string = "";
  CpuVendor: string = "";
  DiskDriveSize: number = 0;
  DiskDriveUnit: string = "";
  DiskDriveType: string = "";
  ImageLarge: string = "";
  InsightURL: string = "";
  IsEducation: boolean = false;
  IsParallelsCapable: boolean = false;
  IsSmartBuy: boolean = false;
  ListPrice: string = "";
  Locality: string = "";
  ManufactureImageLarge: string = "";
  ManufactureName: string = "";
  ManufacturePart: string = "";
  ManufactureURL: string = "";
  MaterialID: string = "";
  MaterialStatus: string = "";
  MaterialType: string = "";
  MemoryFrequency: string = "";
  MemorySize: number = 0;
  MemoryUnit: string = "";
  MemoryType: string = "";
  ParentCatDesc: string = "";
  ParentCatID: string = "";
  ParentMatGrp: string = "";
  ParentMatGrpId: string = "";
  ProductDescLong: string = "";
  ProductDescShort: string = "";
  ProductLine: string = "";
  ProductType: string = "";
  QtyAvailable: string = "";
  ScreenDPI: string = "";
  ScreenResolution: string = "";
  ScreenSize: string = "";
  ShowInResults: boolean = true;

  constructor() {}

  static getPrice(item: InsightInventoryItem): number {
    return parseFloat(item.ListPrice ?? "0");
  }
  static getScreenSize(item: InsightInventoryItem): number {
    return item.ScreenSize !== "" ? parseFloat(item.ScreenSize?.split('"').shift() ?? "0") : 0;
  }

  static buildVendorURL(item: InsightInventoryItem, localeInfo: ILocaleInfo): string {
    const baseURL = environment.productInfoPageBaseUrl;
    const materialID = encodeURI(item.MaterialID).replace("#", "%23");
    const manufactureName = encodeURI(item.ManufactureName);

    let productDesc = item.ProductDescShort;

    if (this.isGermanDeviceWithUniqueScreenSizeFormat(item, localeInfo)) {
      productDesc = this.updateScreenSizePortionOfProductDesc(productDesc);
    }

    productDesc = encodeURI(productDesc).replace(/-/g, "").replace(/%20/g, "-");

    const url: string = `${baseURL}${materialID}/${manufactureName}/${materialID}/${productDesc}/`;

    return url;
  }

  private static isGermanDeviceWithUniqueScreenSizeFormat(item: InsightInventoryItem, localeInfo: ILocaleInfo): boolean {
    return (localeInfo.localeName === constants.DE_GB_LOCALE) && (item.ProductDescShort.includes(constants.CENTIMETER));
  }

  private static updateScreenSizePortionOfProductDesc(productDesc: string): string {
    // example German product description: HP Pro c640 Chromebook - 35.56 cm (14") - Core i5 10310U - 8 GB RAM - 64 GB eMMC - GB
    // this updates the screen size portion to be: - 14" -

    const screenSizePortion = productDesc.split(" - ")[1];
    const regExp = /\(([^)]+)\)/;
    const screenSizeInInchesMatches: RegExpExecArray | null = regExp.exec(screenSizePortion);
    const parsedScreenSize = screenSizeInInchesMatches ? screenSizeInInchesMatches[1] : "";

    return productDesc.replace(screenSizePortion, parsedScreenSize);
  }
}
